module.exports = __webpack_public_path__ + "static/img/5825_phase_function_Paper_Points.6c431c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5825_phase_function_Paper_Points.png
// module id = wAj+
// module chunks = 0